import { createContext, useContext } from "react";

import type { SearchPage } from "./pageSearch";

/** The pages the sidebar offers, shared with every search trigger on screen. */
export const SearchPagesContext = createContext<SearchPage[]>([]);

export function useSearchPages(): SearchPage[] {
    return useContext(SearchPagesContext);
}
